'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiRssOutline = function TiRssOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.3 8.3c-2.7 0-5 2.3-5 5l0 15c0 3.7 3 6.7 6.7 6.7h15c2.8 0 5-2.2 5-5 0-12-9.7-21.7-21.7-21.7z m1.7 23.4c-1.8 0-3.3-1.5-3.3-3.4 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.9-1.5 3.4-3.3 3.4z m7.5 0c-1.4 0-2.5-1.2-2.5-2.5 0-3.3-2.6-5.9-5.8-5.9-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5c5.9 0 10.8 4.9 10.8 10.9 0 1.3-1.1 2.5-2.5 2.5z m6.7 0c-1.4 0-2.5-1.2-2.5-2.5 0-6.9-5.6-12.5-12.5-12.5-1.4 0-2.5-1.2-2.5-2.5s1.1-2.5 2.5-2.5c9.6 0 17.5 7.8 17.5 17.5 0 1.3-1.2 2.5-2.5 2.5z' })
        )
    );
};

exports.default = TiRssOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/rss-outline.js
// module id = 1992
// module chunks = 0